import React from 'react';

import ActiveBar from './ActiveBar';

const withActiveBar = (Component) => {
  const ComponentWithActiveBar = ({ active, ...otherProps }) => (
    <>
      <ActiveBar visible={active} />
      <Component {...otherProps} />
    </>
  );

  ComponentWithActiveBar.displayName = `WithActiveBar(${Component.displayName ||
    Component.name ||
    'Component'})`;

  return ComponentWithActiveBar;
};

export default withActiveBar;
